import { render, staticRenderFns } from "./ProjectCardTenders.vue?vue&type=template&id=9ab80bf4&scoped=true&"
import script from "./ProjectCardTenders.vue?vue&type=script&lang=js&"
export * from "./ProjectCardTenders.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCardTenders.vue?vue&type=style&index=0&id=9ab80bf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab80bf4",
  null
  
)

export default component.exports